import * as moment from 'moment';
export class DateTransform
{
    static formatDateForBackend(rawDate: string)
    {
        return moment(rawDate, "DD/MM/yyyy").format("yyyy-MM-DD");
    }

    static formatDateFormBackend(rawDate: string)
    {
        return moment(rawDate, "yyyy-MM-DD").format("DD/MM/yyyy");
    }
    
    static formatTime(rawTime : string)
    {
        return moment(rawTime, "hh:mm:ss").format("HH:mm");
    }
    
    static formatHistoryTimestamp(timestamp : string)
    {
       return  moment(timestamp, "YYYY-MM-DD hh:mm").format("DD/MM/YYYY  HH:mm");
        // return moment(timestamp, "yyyy-MM-DD HH:mm:ss").format("DD/MM/yyyy HH:mm");
        // return  moment(timestamp, "yyyy-MM-DD hh:mm").format("DD/MM/YYYY  HH:mm");

    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/datetransform/datetransform.ts